/** 与 backend 默认端口一致；未配置环境变量时使用 */
export const DEFAULT_API_BASE_URL = 'http://127.0.0.1:8000/api';

/**
 * 解析前端请求用的 API Base（含 /api 后缀）。
 * - 显式配置了 REACT_APP_API_BASE_URL 时：优先使用配置值；
 * - 未配置时：按当前访问域名/端口推导：
 *   - :8100 / :3000 / :3001 → 1.0 后端 :8000
 *   - :8300 → 严选后端 :8200
 */
export function getResolvedApiBaseUrl(): string {
  const configured = (process.env.REACT_APP_API_BASE_URL || '').trim();
  if (configured) {
    return configured;
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    const port = window.location.port || '';
    // 严选本地前端
    if (port === '8300') {
      const h = host === 'localhost' ? '127.0.0.1' : host;
      return `http://${h}:8200/api`;
    }
    if (host === 'localhost' || host === '127.0.0.1') return 'http://127.0.0.1:8000/api';
    // 开发前端 :8100 / :3000 仍直连本机 8000；生产经 Nginx 80 走同域 /api
    if (port === '8100' || port === '3000' || port === '3001') {
      return `http://${host}:8000/api`;
    }
    return `${window.location.origin}/api`;
  }

  // 生产构建兜底：同域 /api，避免非浏览器环境误用 127.0.0.1
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  return DEFAULT_API_BASE_URL;
}

/** 从 API Base 解析后端端口；严选本地为 8200，1.0 为 8000 */
export function getResolvedApiPort(apiBaseUrl = getResolvedApiBaseUrl()): string | null {
  try {
    if (!apiBaseUrl || apiBaseUrl.startsWith('/')) return null;
    const port = new URL(apiBaseUrl).port;
    return port || null;
  } catch {
    return null;
  }
}

/** 本地后端离线时的启动提示（按实际 API 端口区分 1.0 / 严选） */
export function getLocalBackendOfflineHint(apiBaseUrl = getResolvedApiBaseUrl()): string {
  const port = getResolvedApiPort(apiBaseUrl) || '8000';
  if (port === '8200') {
    return `无法连接后端（8200）。请先启动严选服务：项目根目录执行 ./start-yanxuan-backend.sh`;
  }
  return `无法连接后端（${port}）。请先启动服务：项目根目录执行 ./start-backend.sh，或在 backend 目录执行 npm run start:dev`;
}
